<template>
  <div class="error-main">
    <div class="error-content">
      <img src="../../static/img/not_found.png" />
      <div class="error-text">很抱歉！没有找到您要访问的页面！</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "error"
}
</script>

<style>
.error-main, .error-main * {
  display: block;
}

.error-main {
  width: 100%;
  height: 800px;
}

.error-content {
  position: absolute;
  top: 30%;
  width: 100%;
}

.error-content img{
  margin: auto;
  width: 35%;
  height: auto;
}

.error-content .error-text {
  padding-top: 3rem;
  width: 100%;
  height: 400px;
  text-align: center;
  font-size: 1.5rem;
}

</style>





// WEBPACK FOOTER //
// src/components/notFound.vue